import React from 'react'

// stripe
import { loadStripe } from '@stripe/stripe-js';
import {
    Elements
} from '@stripe/react-stripe-js';

// payment container
import PaymentContainer from './PaymentContainer';

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
// const stripePromise = loadStripe('pk_live_51HwMvOGArJvUi7tHRzWDZfpfpfTFMh6pYcbYYH9RopkVL8UKPEBY1swOH6R1hce8JbKNaFB8z8fTff8AtHBCEuio00fPRIoteO');
const stripePromise = loadStripe('pk_test_51I6V3lJ2zUACMAKB5MaM0mAc3sIM5nIX81tciRdh7pnJFRdSMK8MPFS8yN0Swp380LFgFwmhOFKxdEKIbXEtbskI00mmjMuDvD');

function StripePayment(props) {
    return (
        <React.Fragment>
            <Elements stripe={stripePromise}>
                <PaymentContainer
                    {...props}
                />
            </Elements>
        </React.Fragment>
    )
}


export default StripePayment